export default "__VITE_ASSET__c65945da__"